import React from "react";

const ExpertGeneralInfo = ({ title, description }) => {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-[14px] font-medium leading-[132%] text-[var(--Base-900,#444)] font-circular">
        {title}
      </span>
      <span className="text-[14px] font-[450] leading-[156%] text-text-2 font-circular">
        {description}
      </span>
    </div>
  );
};

export default ExpertGeneralInfo;
